import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { useTabs } from "../hooks/useTabs";
import Input from "../ui/Input";

export default function InventoryMessage(props) {

    const { controller = "", callback = () => { }, route = "", stock_id = "" } = props;

    const fields = [
        { type: "row", key: "note0", value: "" },
        { type: "row", key: "note1", value: "" },
        { type: "row", key: "note2", value: "" },
        { type: "row", key: "note3", value: "" },
        { type: "row", key: "note4", value: "" },
        { type: "row", key: "note5", value: "" },
        { type: "row", key: "note6", value: "" },
        { type: "row", key: "note7", value: "" },
        { type: "row", key: "note8", value: "" },
        { type: "row", key: "note9", value: "" },
        { type: "row", key: "note10", value: "" },
        { type: "row", key: "note11", value: "" },
        { type: "row", key: "note12", value: "" },
    ];

    const { tabs, index, help, update, updateSkip, setIndex, next, prev, refs, getVal, editProps } = useTabs(fields, "note0");

    const saveNote = () => {
        let _note = [];
        tabs.forEach(element => {
            if (element?.value) {
                _note.push(element?.value);
            }
        });
        pubCall("stock.saveNote", { stock_id: stock_id, message: _note }, (_s, _r) => {
            if (_s) {
                showMessage("Note saved!", 2000, "success");
                callback();
            } else {
                showError(_r);
            }
        })
    }

    useEffect(() => {
        pubCall("stock.getNote", { stock_id: stock_id }, (_s, _r) => {
            if (_s) {
                const updates = _r.reduce((acc, element, index) => {
                    acc["note" + index] = element;
                    return acc;
                }, {});
                update(updates);
            } else {
                showError(_r);
            }
        })
    }, []);

    useEffect(() => {
        if (refs?.current[index]) {
            refs.current[index].focus();
        }
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.PAGE_DOWN, action: (e) => { saveNote() } },
            { key: KBD.ARROW_DOWN, action: next },
            { key: KBD.ARROW_UP, action: prev },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.PAGE_DOWN, KBD.ARROW_DOWN, KBD.ARROW_UP]);
        return cleanup;
    }, [index, tabs]);

    const renderNotes = () => {
        const total = 13;
        return Array.from({ length: total }).map((_, i) => {
            const isFirst = i === 0;
            const isLast = i === total - 1;
            const key = `note${i}`;
            const prevKey = `note${i - 1}`;
            const nextKey = `note${i + 1}`;
            return (
                <Input
                    key={key}
                    ref={el => (refs.current[key] = el)}
                    style={{
                        fontFamily: "var(--font-mono)",
                        fontSize: "17px",
                        borderTopLeftRadius: isFirst ? "4px" : "0px",
                        borderTopRightRadius: isFirst ? "4px" : "0px",
                        borderBottomLeftRadius: isLast ? "4px" : "0px",
                        borderBottomRightRadius: isLast ? "4px" : "0px",
                    }}
                    width={730}
                    maxLength={78}
                    {...editProps(`note${i}`)}
                    tabMin={
                        !isFirst
                            ? () => refs.current[prevKey]?.focus()
                            : () => ""
                    }
                    tabMax={
                        !isLast
                            ? () => refs.current[nextKey]?.focus()
                            : ""
                    }
                    onEnter={() => (isLast) ? "" : refs.current[nextKey]?.focus()}
                    onBackSpace={() => {
                        if (getVal(key) === "") {
                            if (!isFirst) {
                                refs.current[prevKey]?.focus();
                            }
                        }
                    }}
                    autoselect={false}
                />
            );
        });
    };

    return (
        <div style={{ "fontSize": "15px", "width": "741px" }}>
            <div className="shim" /><div className="shim" />
            {renderNotes()}
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon />Freeform notes. [{KBD.ESCAPE.label}] to exit. [{KBD.PAGE_DOWN.label}] to save.</Status>
        </div>
    )
}